import { Box, Link as MUILink, Typography } from "@mui/material"
import { Trans, useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { ChallengeBreadcrumbs } from "../../../@shared"

export const Header = () => {
	const { t } = useTranslation("past")

	return (
		<>
			<ChallengeBreadcrumbs sx={{ mt: 3, mb: 6, mx: "auto" }} />

			<Box textAlign='center' maxWidth={744} mx='auto'>
				<Typography variant='h4Serif' component='h1' fontSize='2.25em'>
					{t`title`}
				</Typography>
				<Typography mt={3}>
					<Trans ns='past' i18nKey='description'>
						<MUILink to='/' component={Link} />
					</Trans>
				</Typography>
			</Box>
		</>
	)
}
